import { render, staticRenderFns } from "./ViewRequestedByPage.vue?vue&type=template&id=2fe5071e&"
import script from "./ViewRequestedByPage.vue?vue&type=script&lang=js&"
export * from "./ViewRequestedByPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports